import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";

import {
  selectEndorsementLoadStatus,
  selectEndorsementLoading,
  selectEndorsementLoadingFromBackend,
  selectEndorsementPopulated,
  selectMode,
  useEndorsementSelector,
} from "@redux/slices/endorsement";
import { EndorsementRoutes, getEndorsementPath } from "@routing/paths";

import { LOADED_ON_OPEN_MODES } from "../constants";

export const useEndorsementStepGuard = () => {
  const { policyLocator = "" } = useParams();
  const [searchParams] = useSearchParams();
  const endorsementId = searchParams.get("endorsementId");

  const mode = useEndorsementSelector(selectMode);
  const isPopulated = useEndorsementSelector(selectEndorsementPopulated);
  const loadStatus = useEndorsementSelector(selectEndorsementLoadStatus);
  const loading = useEndorsementSelector(selectEndorsementLoading);
  const loadingFromBackend = useEndorsementSelector(
    selectEndorsementLoadingFromBackend
  );

  const isAwaitingLoad =
    loading.show ||
    loadingFromBackend ||
    (LOADED_ON_OPEN_MODES.includes(mode) &&
      !!endorsementId &&
      loadStatus !== "failed");

  const redirectTo =
    isPopulated || isAwaitingLoad
      ? undefined
      : getEndorsementPath(policyLocator, EndorsementRoutes.INSURED_INFO, {
          endorsementId,
        });

  return { redirectTo };
};
